import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillComponent } from '../components/pill/pill.component';
import { PinIconComponent } from '../components/pin-icon/pin-icon.component';
import { TaskReviewStatusComponent } from '../components/task-risk-status/task-review-status.component';
import { TaskReviewStatus } from '../../../enums/supplier-risk-management/task-review-status';
import { ISupplierTask } from '../../../interfaces/supplier-risk-management/supplier-risk-management';
import { VmePipesModule } from '../../../vme-pipes.module';
import { AMPriorityEnum } from '../../../enums/am-priority.enum';
import { ButtonModule, DialogModule, MessageService, TooltipModule } from 'primeng';
import { DateTimeSelectorComponent } from '../date-time-selector/date-time-selector.component';
import { UpdateSupplierScheduleRequest } from '../../../interfaces/travel-scheduler/update-supplier-schedule-request';
import { Message } from '../../../classes/Message';
import { TravelSchedulerService } from '../../../services/travel-scheduler.service';
import { DateRangePipe } from '../../../pipes/date-format-pipe/date-range.pipe';
import { addHours } from '../../../utils/date-utils';
import { ReviewStatusChange } from '../../../interfaces/supplier-risk-management/review-status-change';
import { TaskStatusDefinitionEnum } from '../../../enums/task-status-definition.enum';

@Component({
  selector: 'risk-management-selected-supplier-task',
  standalone: true,
  imports: [
    CommonModule,
    PillComponent,
    PinIconComponent,
    TaskReviewStatusComponent,
    VmePipesModule,
    TooltipModule,
    ButtonModule,
    DialogModule,
    DateTimeSelectorComponent,
    DateRangePipe,
  ],
  templateUrl: './risk-management-selected-supplier-task.component.html',
  styleUrls: ['./risk-management-selected-supplier-task.component.css'],
})
export class RiskManagementSelectedSupplierTaskComponent implements OnInit {
  @Input() supplierTask: ISupplierTask;

  constructor(
    private travelSchedulerService: TravelSchedulerService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {}

  protected readonly TaskRiskStatusEnum = TaskReviewStatus;
  protected readonly AMPriorityEnum = AMPriorityEnum;
  protected showDateTimeSelector = false;

  protected async saveDriverSchedule() {
    this.showDateTimeSelector = false;

    const request: UpdateSupplierScheduleRequest = {
      jobId: this.supplierTask.jobId,
      taskSupplierSchedules: [
        {
          taskId: this.supplierTask.taskId,
          specifiedPickUpTime: this.currentEarliestPickup,
          specifiedDropOffTime: this.currentEarliestDropoff,
          taskCollectionTravelMode: this.supplierTask.taskCollectionTravelMode,
        },
      ],
    };

    try {
      await this.travelSchedulerService.updateSupplierSchedule(request);
      this.messageService.add(Message.Success('Schedule Saved'));
      this.supplierTask.earliestDriverPickup = this.currentEarliestPickup;
      this.supplierTask.earliestDriverDropoff = this.currentEarliestDropoff;
      this.supplierTask.latestDriverDropoff = addHours(this.currentEarliestDropoff, 1);
    } catch (error) {
      console.error(error);
      this.messageService.add(
        Message.Error('Error Saving Schedule. Refresh the page and try again.'),
      );
    }
  }

  currentEarliestPickup: Date;
  currentEarliestDropoff: Date;
  protected prepDateTimeSelector() {
    this.currentEarliestPickup = this.supplierTask.earliestDriverPickup;
    this.currentEarliestDropoff = this.supplierTask.earliestDriverDropoff;
    this.showDateTimeSelector = true;
  }

  protected readonly TaskStatusDefinitionEnum = TaskStatusDefinitionEnum;

  @Output() reviewStatusChange = new EventEmitter<ReviewStatusChange>();
  protected handleRiskStatusChange(reviewStatus: TaskReviewStatus, taskId: number): void {
    this.reviewStatusChange.emit({ taskId, reviewStatus });
  }
}
